import { createClient, SupabaseClient } from '@supabase/supabase-js';
import { env } from './env';

// Create Supabase client singleton with PKCE flow for OAuth
export const supabase: SupabaseClient = createClient(
  env.SUPABASE_URL,
  env.SUPABASE_ANON_KEY,
  {
    auth: {
      autoRefreshToken: true,
      persistSession: true,
      detectSessionInUrl: true,
      flowType: 'pkce',
    },
  }
);
